import React from "react";

import MenuItem from "@mui/material/MenuItem";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import { Viewer } from "components/auth/types";

import { useSnackbar } from "components/haven-design/snackbar";
import { TableResult, useInterestsTable } from "../interests-table/table-context";
import { useSidebarFilters } from "../sidebar-filters";
import ToolbarButton from "./button";

type Props = {
  recipients: TableResult[];
  currentListId: string;
  viewer: Viewer;
  actionsButton?: boolean;
  closeMenu?: () => void;
  setMessageModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const MessageButton: React.FC<Props> =
(props) => {
  const {
    recipients, actionsButton, closeMenu, setMessageModalOpen,
  } = props;
  const { openSnackbar } = useSnackbar();
  const { hasSelectedAllInterests, selectedPageRange, totalSelectedInterests } = useInterestsTable();
  const { interestListIds } = useSidebarFilters();
  const withQuery = hasSelectedAllInterests || (
    selectedPageRange.from !== null && selectedPageRange.to !== null
  );

  const open = () => {
    if (withQuery || recipients.length > 0) {
      setMessageModalOpen(true);
    } else {
      openSnackbar({ message: "Please select a recipient.", status: "error" });
    }
    if (closeMenu) closeMenu();
  };

  return (
    <>
      {actionsButton ? (
        <MenuItem id="actions-send-message" onClick={open} disabled={interestListIds.length > 1}>
          Send Message {`(${totalSelectedInterests})`}
        </MenuItem>) : (
        <ToolbarButton id="actions-send-message" onClick={open} width={42} disabled={interestListIds.length > 1}>
          <ChatBubbleOutlineIcon
            style={{
              fontSize: 19,
              margin: "8px 0px 0px 11px",
              color: "#B6B6B6",
            }}
          />
        </ToolbarButton>
      )}
    </>
  );
};
